import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { CalendarIcon } from 'lucide-react';
import { cn } from '@fortem-monorepo/js-utilities';
import { Button } from '../../ui/button';
import { Calendar } from '../../ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
export const DateRangePicker = ({ size = 'default', date, setDate, className, calendar, disabled, placeholder, buttonDisabled, }) => {
    const [_dateValue, setDateValue] = useState(date);
    const [open, setOpen] = useState(false);
    const setState = () => {
        setDate && setDate(_dateValue);
    };
    useEffect(() => {
        setDateValue(date);
    }, [date]);
    return (_jsxs(Popover, { open: open, onOpenChange: (open) => {
            setOpen(open);
            if (!open) {
                setState();
            }
        }, children: [_jsx(PopoverTrigger, { asChild: true, children: _jsxs(Button, { id: "date", variant: 'outline', size: size, disabled: buttonDisabled, className: cn(' w-75 justify-start text-left font-normal ', !date && 'text-muted-foreground', className), children: [_jsx(CalendarIcon, { className: cn({
                                'text-muted-foreground/90': !date?.from,
                            }) }), date?.from ? (date.to ? (_jsxs(_Fragment, { children: [format(date.from, 'LLL dd, y'), " - ", format(date.to, 'LLL dd, y')] })) : (format(date.from, 'LLL dd, y'))) : (_jsx("span", { className: cn({
                                'text-muted-foreground': !date?.from,
                            }), children: placeholder ?? 'Pick a date' }))] }) }), _jsx(PopoverContent, { className: "w-auto p-0", align: "start", children: _jsx(Calendar, { initialFocus: true, mode: "range", footer: _jsx("div", { className: 'flex justify-end', children: _jsx(Button, { size: "sm", variant: 'default', onClick: () => {
                                setState();
                                setOpen(false);
                            }, children: "Close" }) }), captionLayout: 'dropdown', endMonth: new Date('2050-12-31'), defaultMonth: _dateValue?.from, selected: _dateValue, disabled: disabled, onSelect: (__date) => {
                        setDateValue({
                            to: __date?.to,
                            from: __date?.from,
                        });
                    }, numberOfMonths: 2, ...calendar }) })] }));
};
